import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import Immutable from "immutable";
import uuid from "./uuid";
import { getFieldConfig, getOperatorConfig, getFieldParts } from "./configUtils";
import { getNewValueForFieldOp, getFirstField, getFirstOperator } from "../utils/ruleUtils";
import { isImmutable } from "./stuff";
import { jsToImmutable } from "../import";
export var getDefaultField = function getDefaultField(config) {
  var canGetFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var parentRuleGroupPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var defaultField = config.settings.defaultField;
  var f = (!parentRuleGroupPath ? defaultField : getDefaultSubField(config, parentRuleGroupPath)) || canGetFirst && getFirstField(config, parentRuleGroupPath) || null;
  // if default LHS is func, convert to Immutable
  if (f != null && typeof f !== "string" && !isImmutable(f)) {
    f = jsToImmutable(f);
  }
  return f;
};
export var getDefaultSubField = function getDefaultSubField(config) {
  var _config$settings;
  var parentRuleGroupPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!parentRuleGroupPath) return null;
  var fieldSeparator = (config === null || config === void 0 || (_config$settings = config.settings) === null || _config$settings === void 0 ? void 0 : _config$settings.fieldSeparator) || ".";
  var parentRuleGroupConfig = getFieldConfig(config, parentRuleGroupPath);
  var f = parentRuleGroupConfig === null || parentRuleGroupConfig === void 0 ? void 0 : parentRuleGroupConfig.defaultField;
  if (f) {
    f = [].concat(_toConsumableArray(getFieldParts(parentRuleGroupPath)), [f]).join(fieldSeparator);
  }
  return f;
};
export var getDefaultFieldSrc = function getDefaultFieldSrc(config) {
  var _config$settings$fiel;
  var canGetFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return canGetFirst && ((_config$settings$fiel = config.settings.fieldSources) === null || _config$settings$fiel === void 0 ? void 0 : _config$settings$fiel[0]) || "field";
};
export var getDefaultOperator = function getDefaultOperator(config, field) {
  var canGetFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var defaultOperator = config.settings.defaultOperator;
  var fieldConfig = getFieldConfig(config, field);
  var fieldOperators = (fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.operators) || [];
  if (defaultOperator && !fieldOperators.includes(defaultOperator)) defaultOperator = null;
  var fieldDefaultOperator = fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.defaultOperator;
  if (fieldDefaultOperator && !fieldOperators.includes(fieldDefaultOperator)) fieldDefaultOperator = null;
  if (!fieldDefaultOperator && canGetFirst) fieldDefaultOperator = getFirstOperator(config, field);
  var fieldHasExplicitDefOp = fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig._origDefaultOperator;
  var op = fieldHasExplicitDefOp && fieldDefaultOperator || defaultOperator || fieldDefaultOperator;
  return op;
};

//used for complex operators like proximity
export var defaultOperatorOptions = function defaultOperatorOptions(config, operator, field) {
  var operatorConfig = operator ? getOperatorConfig(config, operator, field) : null;
  if (!operatorConfig) return null; //new Immutable.Map();
  return operatorConfig.options ? new Immutable.Map(operatorConfig.options && operatorConfig.options.defaults || {}) : null;
};
export var defaultRuleProperties = function defaultRuleProperties(config) {
  var parentRuleGroupPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var item = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var canUseDefaultFieldAndOp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var canGetFirst = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var field = null,
    operator = null,
    fieldSrc = null;
  var showErrorMessage = config.settings.showErrorMessage;
  if (item) {
    var _item$properties, _item$properties2, _item$properties3;
    fieldSrc = item === null || item === void 0 || (_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties.fieldSrc;
    field = item === null || item === void 0 || (_item$properties2 = item.properties) === null || _item$properties2 === void 0 ? void 0 : _item$properties2.field;
    operator = item === null || item === void 0 || (_item$properties3 = item.properties) === null || _item$properties3 === void 0 ? void 0 : _item$properties3.operator;
  } else if (canUseDefaultFieldAndOp) {
    field = getDefaultField(config, canGetFirst, parentRuleGroupPath);
    if (field) {
      fieldSrc = isImmutable(field) ? "func" : "field";
    } else {
      fieldSrc = getDefaultFieldSrc(config);
    }
    operator = getDefaultOperator(config, field, true);
  } else {
    fieldSrc = getDefaultFieldSrc(config);
  }
  var current = new Immutable.Map({
    fieldSrc: fieldSrc,
    field: field,
    operator: operator,
    value: new Immutable.List(),
    valueSrc: new Immutable.List(),
    //used for complex operators like proximity
    operatorOptions: defaultOperatorOptions(config, operator, field)
  });
  if (showErrorMessage) {
    current = current.set("valueError", new Immutable.List());
  }
  if (field && operator) {
    var _getNewValueForFieldO = getNewValueForFieldOp(config, config, current, field, operator, "operator", false),
      newValue = _getNewValueForFieldO.newValue,
      newValueSrc = _getNewValueForFieldO.newValueSrc,
      newValueType = _getNewValueForFieldO.newValueType,
      newValueError = _getNewValueForFieldO.newValueError;
    current = current.set("value", newValue).set("valueSrc", newValueSrc).set("valueType", newValueType);
    if (showErrorMessage) {
      current = current.set("valueError", newValueError);
    }
  }
  return current;
};
export var defaultGroupConjunction = function defaultGroupConjunction(config) {
  var fieldConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  fieldConfig = getFieldConfig(config, fieldConfig); // if `fieldConfig` is field name, not config
  var conjs = fieldConfig && fieldConfig.conjunctions || Object.keys(config.conjunctions);
  if (conjs.length == 1) return conjs[0];
  return config.settings.defaultGroupConjunction || config.settings.defaultConjunction || conjs[0];
};
export var defaultConjunction = function defaultConjunction(config) {
  return config.settings.defaultConjunction || Object.keys(config.conjunctions)[0];
};
export var defaultGroupProperties = function defaultGroupProperties(config) {
  var fieldConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Immutable.Map({
    conjunction: defaultGroupConjunction(config, fieldConfig),
    not: false
  });
};
export var defaultItemProperties = function defaultItemProperties(config, item) {
  var _item$properties4;
  return item && item.type == "group" ? defaultGroupProperties(config, item === null || item === void 0 || (_item$properties4 = item.properties) === null || _item$properties4 === void 0 ? void 0 : _item$properties4.field) : defaultRuleProperties(config, null, item);
};
export var defaultRule = function defaultRule(id, config) {
  return _defineProperty({}, id, new Immutable.Map({
    type: "rule",
    id: id,
    properties: defaultRuleProperties(config)
  }));
};
export var defaultRoot = function defaultRoot(config) {
  var canAddDefaultRule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return new Immutable.Map({
    type: "group",
    id: uuid(),
    children1: new Immutable.OrderedMap(canAddDefaultRule ? _objectSpread({}, defaultRule(uuid(), config)) : {}),
    properties: defaultGroupProperties(config)
  });
};
export var createListFromArray = function createListFromArray(ids) {
  return new Immutable.List(ids);
};
export var emptyProperies = function emptyProperies() {
  return new Immutable.Map();
};